<template>
  <TopSlider></TopSlider>
  <Category></Category>
  <Places></Places>
  <UserFav></UserFav>
  <TestMoni></TestMoni>
  <SubsUser></SubsUser>
</template>

<script>
import TopSlider from './home/topSlider.vue'
import Category from './home/category.vue'
import Places from './home/places.vue'
import UserFav from './home/userFav.vue'
import TestMoni from './home/testimoni.vue'
import SubsUser from './home/subsUser.vue'

export default {
  name: 'MainPage',
  components: {
    TopSlider,
    Category,
    Places,
    UserFav,
    SubsUser,
    TestMoni,
  }
}
</script>

<style>
/* Add your styles here */
</style>
